if(window.custom.mobileImageZoom == 'false'){

  if(screen.width > 991){
  
  $(document).ready(function(){
    $('.product__modal-opener').wrap('<span style="display:block;"></span>').css('display', 'block').parent().zoom({
      magnify: 1.5 
    });
    jQuery('[data-fancybox="images-preview"]').fancybox({
      buttons: [
        "slideShow",
        "thumbs",
        "zoom",
        "fullScreen",
        "share",
        "close"
      ],
      loop: false,
      protect: true
    });
  
  });
  }
}else {

 $(document).ready(function(){
    $('.product__modal-opener').wrap('<span style="display:block;"></span>').css('display', 'block').parent().zoom({
      magnify: 1.5 
    });
    jQuery('[data-fancybox="images-preview"]').fancybox({
      buttons: [
        "slideShow",
        "thumbs",
        "zoom",
        "fullScreen",
        "share",
        "close"
      ],
      loop: false,
      protect: true
    });
  
  });
}
